module.exports = __webpack_public_path__ + "static/media/air_canvas.9b55f78b.jpg";